import angular from "angular";

export default angular
  .module("ticketco/common/security_reports", [
    "ticketco/common",
  ]);
